"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NetlifyCmsWidgetDate = void 0;

var _DateControl = _interopRequireDefault(require("./DateControl"));

var _DatePreview = _interopRequireDefault(require("./DatePreview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Widget = function Widget() {
  let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    name: 'date',
    controlComponent: _DateControl.default,
    previewComponent: _DatePreview.default
  }, opts);
};

const NetlifyCmsWidgetDate = {
  Widget,
  controlComponent: _DateControl.default,
  previewComponent: _DatePreview.default
};
exports.NetlifyCmsWidgetDate = NetlifyCmsWidgetDate;
var _default = NetlifyCmsWidgetDate;
exports.default = _default;